import type { ReactElement } from 'react';
import type { LinkCandidate } from 'modules/applicator/types';
import { Button, openModal } from '@ff-it/ui';
import { ApplicationCandidateDialog } from './ApplicationCandidateDialog';
import { useFormController } from './useFormController';
import { useIsDisabled } from '@ff-it/form';

export function ImplicitCompensation(): ReactElement | null {
  const controller = useFormController();
  const disabled = useIsDisabled();

  if (controller) {
    return (
      <Button
        testId="add-compensation"
        className="ml-2"
        disabled={disabled}
        variant="ghost"
        size="sm"
        title="Compensation from link remainder"
        onClick={() => {
          openModal<LinkCandidate>((props) => (
            <ApplicationCandidateDialog canidates={controller.candidates} {...props} />
          )).then((item) => {
            item && controller.createRow(item);
          });
        }}
        icon="file-invoice-dollar"
      />
    );
  }
  return null;
}
